import { getUrlParts } from './url-parts';
function getErrorMessage(status, requestUrl, sanitiseFunction) {
    const url = (sanitiseFunction && sanitiseFunction(requestUrl)) || requestUrl;
    return `${status} returned from ${url}`;
}
export function getErrorCode(response) {
    return response.body && response.body.errorCode;
}
export function logDefaultServerError(response, serviceName, logger, sanitiseFunction) {
    if (logger && response.status >= 500 && response.status <= 599) {
        const sanitisedUrl = (sanitiseFunction && sanitiseFunction(response.requestURL)) || response.requestURL;
        const { host = '', path = '' } = getUrlParts(sanitisedUrl);
        const url = path ? `${host}/${path}` : `${host}`;
        const errorMessage = getErrorMessage(response.status, url);
        const errorCode = getErrorCode(response);
        const additionalData = {
            serviceName,
            errorStatus: response.status,
            hostname: host,
            path,
            ...(errorCode && { errorCode }),
        };
        logger.sendMessage(errorMessage, { additionalData });
    }
    return response;
}
//# sourceMappingURL=logging.js.map